import UniversalReport from '@tencent/universal-report';
import { getUserId, getUserName } from '@/infrastructure/auth';
import { ENV } from '@/infrastructure/env-config';

const env = ENV.isProd ? 'prod' : 'test';

const getPageFrom = () => {
  const params = new URLSearchParams(window.location.search);
  // bugly 用的是 from，RMonitor 之前用的是 channel，这里都兼容下
  return params.get('from') ?? params.get('channel') ?? '';
};

const reporter = new UniversalReport({
  // 灯塔 APPKEY 或者灯塔实例
  beacon: ENV.datongKey,
  // 启用单页应用模式
  enableSPAMode: true,
  version: '2.0.0',
  // 基础公共参数覆盖
  publicParams: {
    // 用户名(企微id)
    username: getUserName(),
    // 用户id oa版本userId和username一样
    userId: getUserId(),
    // 上报环境
    channelId: env,
    // 管理端页面版本（4: internal, 3: woa）
    portal_version: ENV.isInternal ? 4 : 3,
    // 页面来源
    page_from: getPageFrom(),
  },
  accountInfo: {
    // 账号信息，一般 cookie 中获取
    dt_qq_h5: '', // qq 号
    dt_qqopenid_h5: '', // qq openid
    dt_wxopenid_h5: '', // 微信 openid
    dt_wbopenid_h5: '', // 微博 openid
    dt_mainlogin_h5: 'ioa', // 主登录类型
  },
});

export { reporter };
